import React from 'react'

type Props = {
    search: string,
    setSearch: (c: string) => void,
    placeholderText: string
}

const Search = ({search, setSearch, placeholderText}: Props) => {
  return (
    <div className="w-full pt-6 pb-2">
        <div className="flex w-full items-center gap-3 rounded-xl border border-hair bg-canvas/50 px-4 h-12 transition focus-within:border-accent focus-within:bg-surface focus-within:ring-4 focus-within:ring-accent/15">
            <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0 text-categoriesTextColor" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="7" />
              <path d="m20 20-3.2-3.2" />
            </svg>
            <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={`Search ${placeholderText.toLowerCase()}s`}
                className="w-full bg-transparent text-sm text-ink placeholder:text-categoriesTextColor outline-none"
            />
        </div>
    </div>
  )
}

export default Search
